/* eslint-disable react/void-dom-elements-no-children */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from 'react';
import HelpMenuItem from 'components/atoms/help_menu_item';
import SolicitarEdital from 'components/atoms/solicitar_edital';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { ProfileState } from 'store/modules/profile_store/types';
import { openSupportChat } from 'services/support_chat';

const Help: React.FC = () => {
  const menuItens = [
    {
      id: 1,
      title: 'Conheça o ConLicitação',
      video: 'https://player.vimeo.com/video/788977730',
      page: 'pageConlicita',
    },
    {
      id: 2,
      title: 'Boletins de Licitações',
      video: 'https://player.vimeo.com/video/1036331116',
      page: 'pageBiddings',
    },
    {
      id: 3,
      title: 'Encontrar Licitações',
      video: 'https://player.vimeo.com/video/1038564619',
      page: 'pageBiddingOlineSearch',
    },
    {
      id: 4,
      title: 'Gerenciar Licitações',
      video: 'https://player.vimeo.com/video/1142398490',
      page: 'pageBiddingsManagement',
    },
    {
      id: 5,
      title: 'Monitorar Chat',
      video: 'https://player.vimeo.com/video/1142396205',
      page: 'pageMonitoring',
    },
    {
      id: 6,
      title: 'Gerenciar Documentos',
      video: 'https://player.vimeo.com/video/1142414647',
      page: 'pageDocuments',
    },
    {
      id: 7,
      title: 'Análise de Mercado',
      video: 'https://player.vimeo.com/video/1142395570',
      page: 'pageMarketAnalysis',
    },
    {
      id: 8,
      title: 'Concorrentes',
      video: 'https://player.vimeo.com/video/1148631963',
      page: 'pageConcurrent',
    },
    {
      id: 9,
      title: 'Jurídico Fácil',
      video: 'https://player.vimeo.com/video/1143147817',
      page: 'pageEasyLegal',
    },
    {
      id: 10,
      title: 'ConLicitaGO',
      video: 'https://player.vimeo.com/video/788793022',
      page: 'pageConLicitaGO',
    },
  ];

  const menuSolicitarEdital = [
    {
      id: 1,
      title: 'Solicitação Edital',
      video: '',
      page: 'solicitacaoEdital',
    },
  ];

  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const [titlePage, setTitlePage] = useState<string>(menuItens[0].title);
  const [videoPage, setVideoPage] = useState<string>(menuItens[0].video);
  const [currentPage, setCurrentPage] = useState<string>(menuItens[0].page);

  const selectPage = (title: string, video: string, page: string) => {
    setTitlePage(title);
    setVideoPage(video);
    setCurrentPage(page);
  };

  useEffect(() => {
    document.title = 'Ajuda - ConLicitação';
  }, []);

  return (
    <div className="page-container">
      <div className="container p-4">
        <div className="row mb-3">
          <div className="col-12">
            <h4>Ajuda</h4>
          </div>
        </div>
        {profile && (profile.in_analysis || profile.in_sample) && (
          <div className="alert alert-info mb-3">
            Aqui você encontra vídeos tutoriais sobre as ferramentas da plataforma. Caso tenha
            dúvidas, entre em contato com a nossa{' '}
            <button
              className="btn btn-link m-0 p-0"
              type="button"
              onClick={() => openSupportChat()}
            >
              equipe de atendimento
            </button>
            .
          </div>
        )}
        <div className="row mb-3">
          <div className="col-md-3 col-12 mb-3">
            <div className="list-group">
              {menuItens?.map((item) => (
                <HelpMenuItem
                  key={`item_${item.id}`}
                  item={item.title}
                  current={currentPage === item.page}
                  selectPage={() => selectPage(item.title, item.video, item.page)}
                />
              ))}
            </div>
            <br />
            <div className="list-group">
              <h4 className="bg-white m-0  p-2 border rounded border-bottom-0">Solicitações</h4>
              {menuSolicitarEdital?.map((item) => (
                <HelpMenuItem
                  key={`item_${item.id}`}
                  item={item.title}
                  current={currentPage === item.page}
                  selectPage={() => selectPage(item.title, item.video, item.page)}
                />
              ))}
            </div>
          </div>
          <div className="col-md-9 col-12">
            <div className="card">
              <div className="card-body">
                <h4 className="card-title">{titlePage}</h4>
                {titlePage === 'Solicitação Edital' && <SolicitarEdital />}
                <iframe
                  allowFullScreen={false}
                  frameBorder="0"
                  height="400"
                  src={videoPage}
                  width="100%"
                  title="video"
                />
                <p className="mb-0 mt-3">
                  Caso tenha dúvidas, fale com nossa{' '}
                  <button
                    className="btn btn-link m-0 p-0"
                    type="button"
                    onClick={() => openSupportChat()}
                  >
                    equipe de atendimento
                  </button>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
